import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mock-exam-detail" }
const _hoisted_2 = { class: "container mock-exam-detail__inner" }
const _hoisted_3 = { class: "text-secondary mb-2" }
const _hoisted_4 = { class: "card p-4 mb-4 shadow-sm" }
const _hoisted_5 = { class: "border rounded p-4 mt-3 bg-light" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = {
  key: 0,
  class: "bi bi-arrow-right ms-2 arrow-icon"
}
const _hoisted_10 = { class: "card p-4 shadow-sm" }
const _hoisted_11 = { class: "border rounded p-4 mt-3 bg-light" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = { class: "mt-3" }
const _hoisted_15 = {
  key: 0,
  class: "bi bi-arrow-right ms-2 arrow-icon"
}
const _hoisted_16 = { class: "card p-4 shadow-sm mt-4" }
const _hoisted_17 = { class: "border rounded p-4 mt-3 bg-light" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = { class: "mt-4" }
const _hoisted_20 = { class: "mt-3" }
const _hoisted_21 = {
  key: 0,
  class: "bi bi-arrow-right ms-2 arrow-icon"
}

import { ref, onMounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import { resolveTest } from "@/api/tests"
import { getListeningExam } from "@/api/listening"
import { getReadingExam } from "@/api/reading"
import { getWritingExam } from "@/api/writing"
import { handleError } from "@/services/errorHandler"



export default /*@__PURE__*/_defineComponent({
  __name: 'MockExamPageDtail',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const showReadingInfo = ref(false)
const isReadingConfirmed = ref(false)
const showWritingInfo = ref(false)
const isWritingConfirmed = ref(false)



const level = route.params.level
const testId = route.params.testId

// Test metadata loaded from the backend (durations default to standard IELTS
// timings until the exam data arrives).
const listeningDuration = ref(30)
const readingDuration = ref(60)
const writingDuration = ref(60)
const loadError = ref("")

onMounted(async () => {
  try {
    const resolved = await resolveTest(level, testId)
    const [listening, reading, writing] = await Promise.allSettled([
      getListeningExam(resolved.id),
      getReadingExam(resolved.id),
      getWritingExam(resolved.id),
    ])
    if (listening.status === "fulfilled" && listening.value?.duration_minutes) {
      listeningDuration.value = listening.value.duration_minutes
    }
    if (reading.status === "fulfilled" && reading.value?.duration_minutes) {
      readingDuration.value = reading.value.duration_minutes
    }
    if (writing.status === "fulfilled" && writing.value?.duration_minutes) {
      writingDuration.value = writing.value.duration_minutes
    }
  } catch (e) {
    loadError.value = handleError(e, "MockExamPageDtail.load")
  }
})

const showListeningInfo = ref(false)
const isConfirmed = ref(false)
const startListening = () => {
 showListeningInfo.value = false
  router.push(`/listening-exam/${level}/${testId}`)

}
const startReading = () => {
  showReadingInfo.value = false
  router.push(`/reading-exam/${level}/${testId}`)
}


const startWriting = () => {
  showWritingInfo.value = false
  router.push(`/writing-exam/${level}/${testId}`)
}

function goBack() {
  const hasHistory = window.history.state && window.history.state.back
  if (hasHistory) {
    router.back()
  } else {
    router.push("/mock-exams")
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "mock-exam-detail__back",
        "aria-label": "Back to mock exams",
        onClick: goBack
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          width: "20",
          height: "20",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "aria-hidden": "true"
        }, [
          _createElementVNode("path", {
            d: "M19 12H5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          _createElementVNode("path", {
            d: "M11 18l-6-6 6-6",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1),
        _createElementVNode("span", null, "Back", -1)
      ]))]),
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_unref(level).toUpperCase()) + " - Test " + _toDisplayString(_unref(testId)), 1),
      _cache[31] || (_cache[31] = _createElementVNode("h1", { class: "mb-4" }, "IELTS Familiarisation Test", -1)),
      _cache[32] || (_cache[32] = _createElementVNode("p", { class: "fw-bold border-bottom pb-2" }, "Today", -1)),
      _createElementVNode("div", _hoisted_4, [
        _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "fw-bold" }, "Listening", -1)),
        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "status-text fw-bold" }, "Not completed", -1)),
        _createElementVNode("p", null, [
          _cache[7] || (_cache[7] = _createTextVNode("Timing: ", -1)),
          _createElementVNode("strong", null, _toDisplayString(listeningDuration.value) + " minutes", 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "d-flex align-items-center justify-content-between",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showListeningInfo.value = !showListeningInfo.value)),
            style: {"cursor":"pointer"}
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("i", {
                class: "bi bi-chevron-down me-2",
                style: _normalizeStyle({ transform: showListeningInfo.value ? 'rotate(180deg)' : 'rotate(0deg)' })
              }, null, 4),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "test-info-text" }, "Test information.", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "status-text ms-2" }, "Not confirmed.", -1))
            ])
          ]),
          _createVNode(_Transition, { name: "slide" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_7, [
                _cache[12] || (_cache[12] = _createElementVNode("video", {
                  controls: "",
                  class: "w-100 rounded"
                }, [
                  _createElementVNode("source", {
                    src: "/videos/listening-test.mp4",
                    type: "video/mp4"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _cache[10] || (_cache[10] = _createElementVNode("h5", null, "Ready?", -1)),
                  _cache[11] || (_cache[11] = _createElementVNode("p", null, "Please confirm that you have understood the instructions above.", -1)),
                  _createElementVNode("button", {
                    class: "btn btn-sm confirm-btn d-inline-flex align-items-center justify-content-center",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (isConfirmed.value ? startListening() : isConfirmed.value = true))
                  }, [
                    (isConfirmed.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(isConfirmed.value ? "Start Listening" : "✓ I confirm"), 1)
                  ])
                ])
              ], 512), [
                [_vShow, showListeningInfo.value]
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "fw-bold" }, "Reading", -1)),
        _cache[22] || (_cache[22] = _createElementVNode("p", { class: "status-text fw-bold" }, "Not completed", -1)),
        _createElementVNode("p", null, [
          _cache[15] || (_cache[15] = _createTextVNode("Timing: ", -1)),
          _createElementVNode("strong", null, _toDisplayString(readingDuration.value) + " minutes", 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "d-flex align-items-center justify-content-between",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showReadingInfo.value = !showReadingInfo.value)),
            style: {"cursor":"pointer"}
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("i", {
                class: "bi bi-chevron-down me-2 arrow-icon",
                style: _normalizeStyle({
            transform: showReadingInfo.value ? 'rotate(180deg)' : 'rotate(0deg)'
          })
              }, null, 4),
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "test-info-text" }, "Test information.", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "status-text ms-2" }, "Not confirmed.", -1))
            ])
          ]),
          _createVNode(_Transition, { name: "slide" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_13, [
                _cache[20] || (_cache[20] = _createElementVNode("video", {
                  controls: "",
                  class: "w-100 rounded"
                }, [
                  _createElementVNode("source", {
                    src: "/videos/reading-test.mp4",
                    type: "video/mp4"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_14, [
                  _cache[18] || (_cache[18] = _createElementVNode("h5", null, "Ready?", -1)),
                  _cache[19] || (_cache[19] = _createElementVNode("p", null, "Please confirm that you have understood the instructions above.", -1)),
                  _createElementVNode("button", {
                    class: "btn btn-sm confirm-btn d-inline-flex align-items-center justify-content-center",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (isReadingConfirmed.value ? startReading() : isReadingConfirmed.value = true))
                  }, [
                    (isReadingConfirmed.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(isReadingConfirmed.value ? "Start Reading" : "✓ I confirm"), 1)
                  ])
                ])
              ], 512), [
                [_vShow, showReadingInfo.value]
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _cache[29] || (_cache[29] = _createElementVNode("h3", { class: "fw-bold" }, "Writing", -1)),
        _cache[30] || (_cache[30] = _createElementVNode("p", { class: "status-text fw-bold" }, "Not completed", -1)),
        _createElementVNode("p", null, [
          _cache[23] || (_cache[23] = _createTextVNode("Timing: ", -1)),
          _createElementVNode("strong", null, _toDisplayString(writingDuration.value) + " minutes", 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", {
            class: "d-flex align-items-center justify-content-between",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (showWritingInfo.value = !showWritingInfo.value)),
            style: {"cursor":"pointer"}
          }, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("i", {
                class: "bi bi-chevron-down me-2 arrow-icon",
                style: _normalizeStyle({
            transform: showWritingInfo.value ? 'rotate(180deg)' : 'rotate(0deg)'
          })
              }, null, 4),
              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "test-info-text" }, "Test information.", -1)),
              _cache[25] || (_cache[25] = _createElementVNode("span", { class: "status-text ms-2" }, "Not confirmed.", -1))
            ])
          ]),
          _createVNode(_Transition, { name: "slide" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_19, [
                _cache[28] || (_cache[28] = _createElementVNode("video", {
                  controls: "",
                  class: "w-100 rounded"
                }, [
                  _createElementVNode("source", {
                    src: "/videos/writing-test.mp4",
                    type: "video/mp4"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_20, [
                  _cache[26] || (_cache[26] = _createElementVNode("h5", null, "Ready?", -1)),
                  _cache[27] || (_cache[27] = _createElementVNode("p", null, "Please confirm that you have understood the instructions above.", -1)),
                  _createElementVNode("button", {
                    class: "btn btn-sm confirm-btn d-inline-flex align-items-center justify-content-center",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (isWritingConfirmed.value ? startWriting() : isWritingConfirmed.value = true))
                  }, [
                    (isWritingConfirmed.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_21))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(isWritingConfirmed.value ? "Start Writing" : "✓ I confirm"), 1)
                  ])
                ])
              ], 512), [
                [_vShow, showWritingInfo.value]
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})